import { FORM_FIELD_CONFIG } from '../config/constants';

export interface ValidationResult {
  isValid: boolean;
  error?: string;
}

export const validateCompanyName = (value: string): ValidationResult => {
  const trimmed = value.trim();
  
  if (!trimmed) {
    return { isValid: false, error: 'Company name is required' };
  }
  
  if (trimmed.length > FORM_FIELD_CONFIG.companyName.maxLength) {
    return { 
      isValid: false, 
      error: `Company name must be ${FORM_FIELD_CONFIG.companyName.maxLength} characters or less` 
    };
  }
  
  if (!FORM_FIELD_CONFIG.companyName.pattern.test(trimmed)) {
    return { 
      isValid: false, 
      error: 'Company name contains invalid characters' 
    };
  }
  
  return { isValid: true };
};

export const validateGeography = (value: string): ValidationResult => {
  const trimmed = value.trim();
  
  if (!trimmed) {
    return { isValid: false, error: 'Geography is required' };
  }
  
  if (trimmed.length > FORM_FIELD_CONFIG.geography.maxLength) {
    return { 
      isValid: false, 
      error: `Geography must be ${FORM_FIELD_CONFIG.geography.maxLength} characters or less` 
    };
  }
  
  if (!FORM_FIELD_CONFIG.geography.pattern.test(trimmed)) {
    return { 
      isValid: false, 
      error: 'Geography contains invalid characters' 
    };
  }
  
  return { isValid: true };
};

export const sanitizeInput = (value: string): string => {
  return value.trim().replace(/\s+/g, ' ');
};

export const validateLeadGenerationForm = (companyName: string, geography: string): ValidationResult => {
  const companyValidation = validateCompanyName(companyName);
  if (!companyValidation.isValid) {
    return companyValidation;
  }
  
  const geographyValidation = validateGeography(geography);
  if (!geographyValidation.isValid) {
    return geographyValidation;
  }
  
  return { isValid: true };
};